module.exports = __webpack_public_path__ + "static/media/player_open.48fb7f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/album/player_open.png
// module id = 325
// module chunks = 150